import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "./shared";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Why us", href: "#why" },
  { label: "How it works", href: "#how" },
  { label: "Coach", href: "#coach" },
  { label: "Results", href: "#results" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Header({ onBookClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkClick = () => setOpen(false);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-brand-bg/85 backdrop-blur border-b border-brand-border" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#top" className="flex items-center gap-3" data-testid="brand-logo-link">
          <div className="h-11 w-11 md:h-12 md:w-12 bg-white rounded-full overflow-hidden flex items-center justify-center border border-brand-border shadow-sm">
            <img
              src={BRAND.logo}
              alt={BRAND.name}
              className="w-full h-full object-cover"
              style={{ objectPosition: "center 32%", transform: "scale(1.4)" }}
            />
          </div>
          <span className="font-serif text-lg md:text-xl tracking-tight text-brand-ink">
            Har Ghar Strength
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-brand-ink2 hover:text-brand-ink transition-colors font-medium"
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            onClick={onBookClick}
            className="btn-accent text-sm !py-2.5 !px-5"
            data-testid="header-book-btn"
          >
            Book a Free Consultation
          </button>
        </div>

        <button
          onClick={() => setOpen((s) => !s)}
          className="md:hidden p-2 text-brand-ink"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-brand-bg border-t border-brand-border" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={linkClick}
                className="text-base text-brand-ink font-medium"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
            <button
              onClick={() => { setOpen(false); onBookClick(); }}
              className="btn-accent justify-center mt-2"
              data-testid="mobile-book-btn"
            >
              Book a Free Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
